<div class="flex flex-col gap-4" [class]="direction">
  <!--
    a11y: top close button — initial focus target via [focusInitial]=true,
    visible on both desktop and mobile so AT users always have a keyboard-
    reachable dismiss action at the very top of the dialog.
  -->
  <div class="!flex justify-end">
    <mot-button matType="icon" icon="close"
      [ariaLabel]="closeText"
      class="!border-none !w-min !h-min cursor-pointer !bg-transparent" iconClass="!text-2xl"
      [focusInitial]="true"
      (onClick)="closeCard()" />
  </div>

  <p>
    {{stationCancelledUntilText}} {{toDateText}} {{toDayText}} {{toTimeText}}
  </p>

  @if (cancelMessage.alternativeStops && cancelMessage.alternativeStops.length) {
    <div class="flex flex-col">
      <span>{{listAlternativeStationsText}}:</span>
      <ul class="p-0 list-none m-0">
        @for (stopData of cancelMessage.alternativeStops; track stopData) {
          <li class="font-normal">{{lineText}}
            {{stopData.routeName}} - {{stopData.alternativeStationName}} -
          {{stopData.alternativeStationCode}}</li>
        }
      </ul>
    </div>
  }


  @if (isDesktop) {
    <div class="!flex justify-end !sticky bottom-2 px-2">
      <mot-button [text]="closeText"
        buttonClass="!bg-primary !w-4 !text-white !px-2 !py-3 !rounded-lg !align-middle mt-0.5"
        (onClick)="closeCard()" />
      </div>
    }
  </div>